// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"58cb4906","952":"a352ba3b"}[chunkId] + ".chunk.js";
};